export default "__VITE_ASSET__BfgzB3Ai__"